import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import LoginForm from "../components/LoginForm";
import RegisterForm from "../components/RegisterForm";
import Footer from "../components/Footer";

const AuthPage = () => {
  const [showRegister, setShowRegister] = useState(false);

  return (
    <div className="relative flex h-full w-full overflow-hidden">
      {/* Left: Hero section */}
      <div className="hidden md:block w-1/2 h-screen relative">
        <img
          src={
            "https://mkamalaysia.org.my/wp-content/uploads/2025/04/IMG_4867-scaled-1.jpg"
          }
          alt="Hero"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center md:px-24 lg:px-44 text-white z-10">
          <h2 className="text-sm md:text-2xl lg:text-3xl italic pb-3">
            Nations cannot be reformed without the reformation of the youth
          </h2>
        </div>
      </div>

      {/* Right: Animated Form container */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-4 bg-white">
        <AnimatePresence mode="wait">
          {showRegister ? (
            <motion.div
              key="register"
              initial={{ x: "30%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-30%", opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="w-full max-w-md"
            >
              <RegisterForm onSwitch={() => setShowRegister(false)} />
            </motion.div>
          ) : (
            <motion.div
              key="login"
              initial={{ x: "30%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-30%", opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="w-full max-w-md"
            >
              <LoginForm onSwitch={() => setShowRegister(true)} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <Footer />
    </div>
  );
};

export default AuthPage;
